var exports = {
  "g": "attachButton__JwXcKv",
};

module.exports = exports;
